var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0042B0",
    d: "M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8m0 14.4A6.407 6.407 0 0 1 1.6 8c0-3.529 2.871-6.4 6.4-6.4s6.4 2.871 6.4 6.4-2.871 6.4-6.4 6.4m.8-9.6a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0m0 2.4v4a.8.8 0 0 1-1.6 0v-4a.8.8 0 0 1 1.6 0"
  })));
};
export default SvgInfoIcon;